import { Component } from '@angular/core';
import { StripeService } from '../../services/products.service';
import { Product } from '../../models/Product';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-onboarding4',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './onboarding4.component.html',
  styleUrl: './onboarding4.component.scss',
})
export class Onboarding4Component {
  products: Product[] = [];
  options: Product[] = [];
  selectedProduct?: Product;
  selectedOptions: Product[] = [];
  readonly canSkip: boolean;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private stripeService: StripeService,
    private storageService: StorageService,
  ) {
    this.canSkip = this.route.snapshot.data['canSkip'] === true;
  }

  async ngOnInit() {
    const products = await firstValueFrom(this.stripeService.getProducts());
    const options = await firstValueFrom(this.stripeService.getOptions());

    this.products = products;
    this.options = options;

    // Restore pending purchase if exists
    this.restorePendingPurchase();
  }

  private restorePendingPurchase(): void {
    const pendingPurchase = this.storageService.getPendingPurchase();
    if (pendingPurchase) {
      // Find and restore selected product
      const foundProduct = this.products.find((p) => p.product_id === pendingPurchase.selectedProduct?.product_id);
      if (foundProduct) {
        this.selectedProduct = foundProduct;
      }

      // Restore selected options
      this.selectedOptions = this.options.filter((option) => pendingPurchase.selectedOptions.some((selectedOption) => selectedOption.product_id === option.product_id));

      // Clear the pending purchase since we've restored it
      this.storageService.clearPendingPurchase();
    }
  }

  isBuyable(): boolean {
    return this.selectedProduct !== undefined;
  }

  skip(): void {
    if (!this.canSkip) {
      return;
    }

    this.router.navigate(['']);
  }

  selectProduct(product: Product) {
    this.selectedProduct = product;
  }

  toggleOption(option: Product) {
    const index = this.selectedOptions.findIndex((elt) => elt.product_id === option.product_id);

    if (index !== -1) {
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(option);
    }
  }

  isOptionSelected(option: Product): boolean {
    return this.selectedOptions.findIndex((elt) => elt.product_id === option.product_id) !== -1;
  }

  async buy() {
    if (!this.selectedProduct) {
      return;
    }

    // Check if user is anonymous before proceeding with purchase
    if (this.storageService.isAnonymous()) {
      // Save current selection to localStorage
      this.storageService.setPendingPurchase(this.selectedProduct, this.selectedOptions);

      // Redirect to signup page
      this.router.navigate(['/signup-before-purchase']);
      return;
    }

    let array = this.selectedOptions.map((elt) => elt.product_id);
    array.unshift(this.selectedProduct.product_id);
    const buyResponse = await firstValueFrom(this.stripeService.buy(array));

    window.location.href = buyResponse.session_url;
  }
}
